export default "__VITE_ASSET__DfbObudZ__"